
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/pelaksanaan/tugas-pokok",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/pelaksanaan/tugas-pokok/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/pelaksanaan/tugas-pokok"])
      });
    }
  